<template>
    <div>
        <!-- actions -->
        <template slot="action">
            <a-button-group style="margin-right: 4px;">
                <a-button>操作</a-button>
                <a-button>操作</a-button>
                <a-button>
                    <a-icon type="ellipsis"/>
                </a-button>
            </a-button-group>
            <a-button type="primary">主操作</a-button>
        </template>

        <a-card style="margin-top: 24px" :bordered="false">
            <a-steps>
                <a-step
                        :title="step.title"
                        :status="step.status"
                        v-for="(step,index) in row.step_list"
                        :key="index"
                        :description="step.desc"
                ></a-step>
            </a-steps>
        </a-card>

        <a-card style=" " :bordered="true">
            <detail-list :col="1">
                <detail-list-item term="订单编号">{{row.code}}</detail-list-item>
                <detail-list-item term="订单金额">{{row.order_price|price}}元 = {{row.goods_price|price}}元(商品)
                </detail-list-item>
                <detail-list-item
                        term="应付金额"
                >{{row.pay_price|price}}元 = {{row.order_price|price}}元(订单) - {{row.discount_price|price}}元(优惠) +
                    {{row.fix_price|price}}元(调价)
                </detail-list-item>
                <detail-list-item term="已付金额">{{row.payed_price|price}}元</detail-list-item>
                <detail-list-item term="累计退款">{{row.refund_price|price}}元</detail-list-item>
                <detail-list-item term="商家备注">
                    <div v-if="businessNoteEdit==false">
                        {{row.business_note}}
                        <a-icon type="edit" @click="businessNoteEdit=true"/>
                    </div>
                    <div v-else>
                        <a-input style="width: 200px; margin-right: 10px;" v-model="row.business_note"/>
                        <a @click="onBusinessNoteEdit()">保存</a>
                    </div>
                </detail-list-item>
            </detail-list>
            <detail-list title="客户信息" :col="2">
                <detail-list-item term="用户名">{{row.user_name}}</detail-list-item>
                <detail-list-item term="买家备注">{{row.buyer_note}}</detail-list-item>
                <detail-list-item term="联系人">{{row.buyer.name}} {{row.buyer.phone}}</detail-list-item>
            </detail-list>
            <a-card type="inner" title="分销信息">
                <detail-list title="分销员" size="small" v-if="row.seller">
                    <detail-list-item term="用户名">{{row.seller.user_name}}</detail-list-item>
                    <detail-list-item term="等级">{{row.seller.group_name}}</detail-list-item>
                    <detail-list-item term="提成金额">{{row.seller.rewards_price|price}}元</detail-list-item>
                </detail-list>
                <a-divider style="margin: 6px 0" v-if="row.team"/>
                <detail-list title="团长" size="small" v-if="row.team">
                    <detail-list-item term="用户名">{{row.team.user_name}}</detail-list-item>
                    <detail-list-item term="等级">{{row.team.group_name}}</detail-list-item>
                    <detail-list-item term="提成金额">{{row.team.rewards_price|price}}元</detail-list-item>
                </detail-list>
                <a-divider style="margin:6px 0" v-if="row.dealtown"/>
                <detail-list title="平台" size="small" v-if="row.dealtown">
                    <detail-list-item term="手续费">{{row.dealtown.pay_fee|price}}元</detail-list-item>
                    <detail-list-item term="提成">{{row.dealtown.rewards_price|price}}元</detail-list-item>
                    <detail-list-item term="线下结算">{{row.dealtown.offline_price|price}}元</detail-list-item>
                </detail-list>
            </a-card>
        </a-card>
        <a-card style="margin-top: 24px" :bordered="false" title="商品清单">
            <a-table rowKey="id" :columns="goodsColumns" :dataSource="row.items" :pagination="false">
        <span slot="goods" slot-scope="text,record">
          <img style="width: 38px ; height: 38px; float: left" :src="record.pic_url"/>
          <div style="margin-left: 10px; float: left">
            {{record.title}}
            <br/>
            <span style="color: #999">{{record.sku.sku_formart}}</span>
            <br/>
                      <span style="color: #FF9934">入离日期：{{record.time_start}} ~ {{record.time_end}}</span>

          </div>

        </span>
                <span slot="count" slot-scope="text,record">
          {{record.count}}
          <br/>
          <span style="color: #999">退货:{{record.refund_count}}</span>
        </span>
                <span slot="goods_price" slot-scope="text,record">
          {{record.pay_price|price}}
          <br/>
          <span style="color: #999">商品:{{record.goods_price|price}}</span>
          <br/>
          <span style="color: #999">优惠:{{record.discount_price|price}}</span>
          <a-divider type="vertical"/>
          <span style="color: #999">调价:{{record.fix_price|price}}</span>
          <br/>
          <span style="color: #999">退款:{{record.refund_price|price}}</span>
        </span>
                <span slot="rewards_price" slot-scope="text,record">
          {{record.order_fee|price}}
          <br/>
          <span style="color: #999" v-if="record.seller">分销员:{{record.seller.rewards_price|price}}</span>
          <br/>
          <span style="color: #999" v-if="record.team">团长:{{record.team.rewards_price|price}}</span>
          <br/>
          <span
                  style="color: #999"
                  v-if="record.dealtown"
          >平台:{{record.dealtown.rewards_price|price}}</span>
          <br/>
          <span style="color: #999" v-if="record.dealtown">手续费:{{record.dealtown.pay_fee|price}}</span>
          <br/>
          <span
                  style="color: #999"
                  v-if="record.dealtown"
          >线下结算:{{record.dealtown.offline_price|price}}</span>
        </span>
                <span slot="actions" slot-scope="text,record">
          <a @click="refundHandle(record)">退款/退货</a>
          <a-divider type="vertical"/>
          <a @click="priceHandle(record)">调价</a>
        </span>
            </a-table>
        </a-card>

        <a-card style="margin-top: 24px" :bordered="false" title="优惠明细">
            <a-table
                    v-if="row.discount_list.length>0"
                    rowKey="id"
                    :columns="discountColumns"
                    :dataSource="row.discount_list"
                    :pagination="false"
            ></a-table>
            <div class="no-data" v-else>
                <a-icon type="frown-o"/>
                暂无数据
            </div>
        </a-card>
        <!-- 操作 -->
        <a-card style="margin-top: 24px" :bordered="false">
            <a-tabs defaultActiveKey="1">
                <a-tab-pane tab="售后日志" key="1">
                    <a-table
                            rowKey="id"
                            :columns="serviceLogColumns"
                            :dataSource="row.serviceList"
                            :pagination="false"
                    >
            <span slot="status" slot-scope="text,record">
              <a-badge v-if="record.admin_status==1" status="error" text="待处理"/>
              <a-badge v-else-if="record.admin_status==2" status="warning" text="拒绝"/>
              <a-badge v-else-if="record.admin_status==3" status="success" text="同意"/>
            </span>
                        <span slot="create_time" slot-scope="text,record">{{record.create_time|timeFormat}}</span>
                        <span slot="complete_time" slot-scope="text,record">{{record.complete_time|timeFormat}}</span>
                        <span slot="actions" slot-scope="text,record,index">
              <a v-if="record.admin_status==1" @click="orderServiceEdit(record.id,index)">处理</a>
              <a v-else @click="orderServiceEdit(record.id,index)">查看</a>
            </span>
                    </a-table>
                </a-tab-pane>
                <a-tab-pane tab="操作日志" key="2">
                    <div style="padding: 20px">
                        <a-timeline>
                            <a-timeline-item v-for="log in row.logList" :key="log.id">
                                {{log.create_time|timeFormat}}
                                <b>{{log.user_name}}</b>
                                {{log.title}}
                                <span v-if="log.note" class="gray">备注:{{log.note}}</span>
                            </a-timeline-item>
                        </a-timeline>
                    </div>
                </a-tab-pane>
            </a-tabs>
        </a-card>

        <a-affix :offsetBottom="0">
            <div
                    style="background: #fff; padding: 10px 0 20px 10px ; border-top: 1px solid #eee ; text-align: center  "
            >
                <a-button-group>
                    <a-button
                            size="large"
                            v-for="(button,bindex) in row.status_data.buttons"
                            @click="orderEdit(button.type)"
                            :type="button.class?button.class:null"
                    >{{button.name}}
                    </a-button>
                </a-button-group>
            </div>
        </a-affix>

        <a-modal title="操作" :width="800" v-model="serviceVisible" @ok="handleServiceOk">
            <a-spin :spinning="saveLoading">
                <a-form>
                    <a-form-item
                            :labelCol="labelCol"
                            :wrapperCol="wrapperCol"
                            label="类型"
                            hasFeedback
                    >{{serviceLogFormData.title}}
                    </a-form-item>

                    <a-form-item
                            :labelCol="labelCol"
                            :wrapperCol="wrapperCol"
                            label="描述"
                            hasFeedback
                    >{{serviceLogFormData.note}}
                    </a-form-item>

                    <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="图片" hasFeedback>
                        <div v-if="serviceLogFormData.pics.length>0">
                            <img
                                    :key="index"
                                    v-for="(pic,index) in serviceLogFormData.pics"
                                    :src="pic"
                                    style="width: 100px; margin-right: 10px;"
                            />
                        </div>
                        <div v-else>(无)</div>
                    </a-form-item>

                    <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处理意见" hasFeedback>
                        <a-input
                                v-if="serviceLogFormData.admin_status==1"
                                v-model="serviceLogFormData.admin_note"
                                placeholder="请输入反馈意见,客户将看到您的反馈意见"
                        />
                        <div v-else>{{serviceLogFormData.admin_note}}</div>
                    </a-form-item>
                </a-form>
            </a-spin>
            <template slot="footer">
                <a-button key="cancel" @click="handleServiceCancel">取消</a-button>

                <a-popconfirm
                        title="确定拒绝申请吗?此操作不可恢复"
                        @confirm="handleServiceOk(2)"
                        okText="确定"
                        cancelText="取消"
                >
                    <a-button key="no" :loading="saveLoading" type="primary">拒绝</a-button>
                </a-popconfirm>
                <a-popconfirm
                        title="确定同意申请吗?此操作不可恢复"
                        @confirm="handleServiceOk(3)"
                        okText="确定"
                        cancelText="取消"
                >
                    <a-button key="yes" :loading="saveLoading" type="primary">同意</a-button>
                </a-popconfirm>
            </template>
        </a-modal>

        <a-modal title="调价操作" :width="800" v-model="priceVisible" @ok="handlePirceSave">
            <a-spin :spinning="saveLoading">
                <a-form>
                    <a-form-item
                            label="手动调价"
                            :labelCol="labelCol"
                            :wrapperCol="wrapperCol"
                            extra="正数是加价,负数是减价"
                    >
                        <PriceInput :formData="priceFormData" field="price" placeholder="手动调价"/>
                    </a-form-item>
                    <a-form-item label="调价理由" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input v-model="priceFormData.comment" placeholder="请输入理由"/>
                    </a-form-item>
                </a-form>
            </a-spin>
        </a-modal>

        <a-modal title="退款退货操作" :width="800" v-model="refundVisible" @ok="handleRefundSave">
            <a-spin :spinning="saveLoading">
                <a-form>
                    <a-form-item
                            label="退款"
                            :labelCol="labelCol"
                            :wrapperCol="wrapperCol"
                            :extra="'已付'+(refundFormData.pay_price/100)+'元,已退'+(refundFormData.refund_price/100)+'元,最多可退'+((refundFormData.pay_price-refundFormData.refund_price)/100)+'元'"
                    >
                        <PriceInput :formData="refundFormData" field="price" placeholder="输入退款金额"/>
                    </a-form-item>

                    <a-form-item
                            label="退货数量"
                            :labelCol="labelCol"
                            :wrapperCol="wrapperCol"
                            :extra="'购买'+(refundFormData.buy_count)+'件,已退'+(refundFormData.refund_count)+'件,最多可退'+(refundFormData.buy_count-refundFormData.refund_count)+'件'"
                    >
                        <a-input type="number" v-model="refundFormData.count" placeholder="请输入退货数量"/>
                    </a-form-item>

                    <a-form-item label="理由" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input v-model="refundFormData.comment" placeholder="请输入理由"/>
                    </a-form-item>
                </a-form>
            </a-spin>
        </a-modal>

        <a-modal title="推广" v-model="shareVisible" @ok="shareVisible=false">
            <p style="text-align: center">
                <img :src="share.wxmini_pic_url"/>
            </p>
        </a-modal>
    </div>
</template>

<script>
    import {mixinDevice} from '@/utils/mixin'
    import {PageView} from '@/components/layouts'
    import DetailList from '@/components/tools/DetailList'
    import PriceInput from '@/components/PriceInput/'

    const DetailListItem = DetailList.Item
    import {
        serviceApplyDo,
        priceFix,
        goodsRefund,
        orderRecover,
        businessNoteEdit,
        adminNoteEdit,
        orderClose,
        orderCancel,
        tuanComplete
    } from '@/api/order'
    import {getOrderDetail, orderConfirm, orderUse} from '@/api/hotelOrder'

    export default {
        name: 'HotelOrderDetail',
        components: {
            PageView,
            DetailList,
            PriceInput,
            DetailListItem
        },
        mixins: [mixinDevice],
        data() {
            return {
                labelCol: {
                    xs: {span: 24},
                    sm: {span: 5}
                },
                wrapperCol: {
                    xs: {span: 24},
                    sm: {span: 12}
                },
                businessNoteEdit: false,
                adminNoteEdit: false,
                saveLoading: false,
                shareVisible: false,
                share: {
                    wxmini_pic_url: ''
                },
                isFenxiao: false,
                orderId: this.$route.query.id,
                serviceVisible: false,
                priceVisible: false,
                refundVisible: false,
                priceFormData: {
                    order_goods_id: 0,
                    comment: '',
                    price: 0
                },
                refundFormData: {
                    order_goods_id: 0,
                    order_id: 0,
                    pay_price: 0,
                    refund_price: 0,
                    refund_count: 0,
                    buy_count: 0,
                    count: 0,
                    price: 0,
                    comment: ''
                },
                serviceLogFormData: {
                    id: 0,
                    title: '',
                    pics: []
                },
                row: {
                    buyer: {
                        name: '',
                        phone: ''
                    },
                    items: [],
                    logList: [],
                    serviceList: [],
                    step_list: [],
                    discount_list: [],
                    status_data: {
                        step: 0,
                        buttons: []
                    }
                },
                goodsColumns: [
                    {
                        title: '#',
                        dataIndex: 'id'
                    },
                    {
                        title: '商品',
                        dataIndex: 'title',
                        scopedSlots: {customRender: 'goods'}
                    },
                    {
                        title: '数量',
                        dataIndex: 'count',
                        scopedSlots: {customRender: 'count'}
                    },
                    {
                        title: '价格信息',
                        dataIndex: 'goods_price',
                        scopedSlots: {customRender: 'goods_price'}
                    },
                    {
                        title: '提成',
                        dataIndex: 'rewards_price',
                        scopedSlots: {customRender: 'rewards_price'}
                    },
                    {
                        title: '操作',
                        dataIndex: 'actions',
                        scopedSlots: {customRender: 'actions'}
                    }
                ],
                serviceLogColumns: [
                    {
                        title: '类型',
                        dataIndex: 'title'
                    },
                    {
                        title: '状态',
                        dataIndex: 'admin_status',
                        scopedSlots: {customRender: 'status'}
                    },
                    {
                        title: '提交时间',
                        dataIndex: 'create_time',
                        scopedSlots: {customRender: 'create_time'}
                    },
                    {
                        title: '处理时间',
                        dataIndex: 'complete_time',
                        scopedSlots: {customRender: 'complete_time'}
                    },
                    {
                        title: '经办人',
                        dataIndex: 'admin_user_name'
                    },
                    {
                        title: '操作',
                        dataIndex: 'id',
                        scopedSlots: {customRender: 'actions'}
                    }
                ],
                discountColumns: [
                    {
                        title: '类型',
                        dataIndex: 'title'
                    },
                    {
                        title: '备注',
                        dataIndex: 'note'
                    },
                    {
                        title: '优惠',
                        dataIndex: 'price',
                        customRender: text => {
                            return (text / 100).toFixed(2)
                        }
                    }
                ]
            }
        },

        mounted() {
            let that = this
            that.getDetail()
        },
        methods: {
            getDetail() {
                let that = this
                getOrderDetail({
                    id: that.orderId
                })
                    .then(res => {
                        that.row = res.data
                        that.isFenxiao = res.data.isFenxiao
                    })
                    .catch(err => {
                        self.$message.error(err.data.msg)
                    })
            },
            orderEdit(type) {
                console.log(type)
                let that = this
                switch (type) {
                    case 'confirm':
                        that.onOrderConfirm()
                        break
                    case 'toUse':
                        that.onOrderUse()
                        break
                    case 'recover':
                        that.onOrderRecover()
                        break
                    case 'cancel':
                        that.onOrderCancel()
                        break
                    case 'close':
                        that.onOrderClose()
                        break
                    case 'tuanShare':
                        that.onTuanShare()
                        break
                    case 'tuanComplete':
                        that.onTuanComplete()
                        break
                }
            },
            onOrderConfirm() {
                let that = this
                this.$confirm({
                    title: '确认订单?',
                    content: '此操作不可恢复,请谨慎操作!',
                    onOk() {
                        orderConfirm({
                            order_id: that.row.id
                        })
                            .then(res => {
                                that.getDetail()
                                that.$message.success('确认成功')
                            })
                            .catch(err => {
                                that.$message.error(err.data.msg)
                            })
                    },
                    onCancel() {
                    }
                })
            },
            onOrderUse() {
                let that = this
                this.$confirm({
                    title: '确认使用?',
                    content: '此操作不可恢复,请谨慎操作!',
                    onOk() {
                        orderUse({
                            order_id: that.row.id
                        })
                            .then(res => {
                                that.getDetail()
                                that.$message.success('使用成功')
                            })
                            .catch(err => {
                                that.$message.error(err.msg)
                            })
                    },
                    onCancel() {
                    }
                })
            },
            onOrderRecover() {
                let that = this
                this.$confirm({
                    title: '确认恢复订单状态?',
                    content: '',
                    onOk() {
                        orderRecover({
                            order_id: that.row.id
                        })
                            .then(res => {
                                that.getDetail()
                                that.$message.success('操作成功')
                            })
                            .catch(err => {
                                that.$message.error(err.data.msg)
                            })
                    },
                    onCancel() {
                    }
                })
            },
            onOrderClose() {
                let that = this
                this.$confirm({
                    title: '确认关闭订单?',
                    content: '关闭后订单无法再次支付',
                    onOk() {
                        orderClose({
                            order_id: that.row.id
                        })
                            .then(res => {
                                that.getDetail()
                                that.$message.success('操作成功')
                            })
                            .catch(err => {
                                that.$message.error(err.data.msg)
                            })
                    },
                    onCancel() {
                    }
                })
            },
            onOrderCancel() {
                let that = this
                this.$confirm({
                    title: '确认取消订单?',
                    content: '订单取消后分销员和供应商无法获得任何收益',
                    onOk() {
                        orderCancel({
                            order_id: that.row.id
                        })
                            .then(res => {
                                that.getDetail()
                                that.$message.success('操作成功')
                            })
                            .catch(err => {
                                that.$message.error(err.data.msg)
                            })
                    },
                    onCancel() {
                    }
                })
            },
            onTuanComplete() {
                let that = this
                this.$confirm({
                    title: '确认强制成团?',
                    content: '该团购的所有订单都会被强制成团',
                    onOk() {
                        tuanComplete({
                            order_id: that.row.id
                        })
                            .then(res => {
                                that.getDetail()
                                that.$message.success('操作成功')
                            })
                            .catch(err => {
                                that.$message.error(err.data.msg)
                            })
                    },
                    onCancel() {
                    }
                })
            },
            priceHandle(record) {
                let that = this
                that.priceVisible = true
                that.priceFormData = {
                    order_goods_id: record.id,
                    price: record.fix_price,
                    comment: ''
                }
            },
            handlePirceSave() {
                let that = this
                that.saveLoading = true
                priceFix(that.priceFormData)
                    .then(res => {
                        that.getDetail()
                        that.$message.success('保存成功')
                        that.priceVisible = false
                        that.saveLoading = false
                    })
                    .catch(err => {
                        that.saveLoading = false
                        that.$message.error(err.data.msg)
                    })
            },

            refundHandle(record) {
                let that = this
                that.refundVisible = true
                that.refundFormData = {
                    order_goods_id: record.id,
                    order_id: record.order_id,
                    refund_price: record.refund_price,
                    pay_price: record.pay_price,
                    refund_count: record.refund_count,
                    buy_count: record.count,
                    comment: '',
                    price: 0,
                    count: 0
                }
            },
            handleRefundSave() {
                let that = this
                that.saveLoading = true
                goodsRefund(that.refundFormData)
                    .then(res => {
                        that.getDetail()
                        that.$message.success('保存成功')
                        that.refundVisible = false
                        that.saveLoading = false
                    })
                    .catch(err => {
                        that.saveLoading = false
                        that.$message.error(err.data.msg)
                    })


            },

            orderServiceEdit(record, index) {
                console.log('index', index)
                let that = this
                that.serviceVisible = true
                that.serviceLogFormData = {...that.row.serviceList[index]}
            },
            handleServiceCancel() {
                let that = this
                that.serviceVisible = false
            },
            handleServiceOk(type) {
                let that = this
                that.saveLoading = true
                serviceApplyDo({
                    id: that.serviceLogFormData.id,
                    admin_note: that.serviceLogFormData.admin_note,
                    status: type
                })
                    .then(res => {
                        that.getDetail()
                        that.$message.success('处理成功')
                        that.serviceVisible = false
                        that.saveLoading = false
                    })
                    .catch(err => {
                        that.saveLoading = false
                        that.$message.error(err.data.msg)
                    })
            },
            onTuanShare() {
                let that = this
                that.shareVisible = true
                that.share.wxmini_pic_url = that.row.status_data.buttons[0].wxmini_pic_url
            },
            onBusinessNoteEdit() {
                let that = this
                that.businessNoteEdit = false
                businessNoteEdit({
                    id: that.row.id,
                    note: that.row.business_note
                })
                    .then(res => {
                    })
                    .catch(err => {
                        that.$message.error(err.data.msg)
                    })
            },
            onAdminNoteEdit() {
                let that = this
                that.adminNoteEdit = false
                adminNoteEdit({
                    id: that.row.id,
                    note: that.row.admin_note
                })
                    .then(res => {
                    })
                    .catch(err => {
                        that.$message.error(err.data.msg)
                    })
            }
        },
        filters: {}
    }
</script>

<style lang="less" scoped>
    .detail-layout {
        margin-left: 44px;
    }

    .text {
        color: rgba(0, 0, 0, 0.45);
    }

    .heading {
        color: rgba(0, 0, 0, 0.85);
        font-size: 20px;
    }

    .no-data {
        color: rgba(0, 0, 0, 0.25);
        text-align: center;
        line-height: 64px;
        font-size: 16px;

        i {
            font-size: 24px;
            margin-right: 16px;
            position: relative;
            top: 3px;
        }
    }

    .mobile {
        .detail-layout {
            margin-left: unset;
        }

        .text {
        }

        .status-list {
            text-align: left;
        }
    }
</style>